import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Grid,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';

const CustomerAddForm = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    Vorname: '',
    Nachname: '',
    company: '',
    email: '',
    phone: '',
    billingemail: '',
    billingaddress: '',
    billingzip: '',
    billingcity: '',
    billingcountry: 'Deutschland',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    
    // Pflichtfelder prüfen
    if (!formData.username) newErrors.username = 'Benutzername ist erforderlich';
    if (!formData.password) {
      newErrors.password = 'Passwort ist erforderlich';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Passwort muss mindestens 8 Zeichen lang sein';
    }
    if (!formData.company) newErrors.company = 'Firma ist erforderlich';
    if (!formData.email) newErrors.email = 'E-Mail ist erforderlich';
    if (!formData.phone) newErrors.phone = 'Telefonnummer ist erforderlich';
    if (!formData.billingemail) newErrors.billingemail = 'Rechnungs-E-Mail ist erforderlich';
    if (!formData.billingaddress) newErrors.billingaddress = 'Rechnungsadresse ist erforderlich';
    if (!formData.billingzip) newErrors.billingzip = 'PLZ ist erforderlich';
    if (!formData.billingcity) newErrors.billingcity = 'Ort ist erforderlich';
    if (!formData.billingcountry) newErrors.billingcountry = 'Land ist erforderlich';
    
    // E-Mail-Format prüfen
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Ungültiges E-Mail-Format';
    }
    
    // Rechnungs-E-Mail-Format prüfen
    if (formData.billingemail && !/\S+@\S+\.\S+/.test(formData.billingemail)) {
      newErrors.billingemail = 'Ungültiges E-Mail-Format';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <>
      <DialogTitle>
        <SoftTypography variant="h5" fontWeight="medium">
          Neuen Kunden anlegen
        </SoftTypography>
      </DialogTitle>
      
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <SoftBox py={2}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <SoftTypography variant="h6" fontWeight="medium" mb={2}>
                  Zugangsdaten
                </SoftTypography>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="username"
                    placeholder="Benutzername"
                    value={formData.username}
                    onChange={handleChange}
                    error={!!errors.username}
                  />
                  {errors.username && (
                    <SoftTypography variant="caption" color="error">
                      {errors.username}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <SoftBox mb={2}>
                  <SoftInput
                    type="password"
                    name="password"
                    placeholder="Passwort"
                    value={formData.password}
                    onChange={handleChange}
                    error={!!errors.password}
                  />
                  {errors.password && (
                    <SoftTypography variant="caption" color="error">
                      {errors.password}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12}>
                <SoftTypography variant="h6" fontWeight="medium" mb={2}>
                  Kundendaten
                </SoftTypography>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="Vorname"
                    placeholder="Vorname"
                    value={formData.Vorname}
                    onChange={handleChange}
                    error={!!errors.Vorname}
                  />
                  {errors.Vorname && (
                    <SoftTypography variant="caption" color="error">
                      {errors.Vorname}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="Nachname"
                    placeholder="Nachname"
                    value={formData.Nachname}
                    onChange={handleChange}
                    error={!!errors.Nachname}
                  />
                  {errors.Nachname && (
                    <SoftTypography variant="caption" color="error">
                      {errors.Nachname}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="company"
                    placeholder="Firma"
                    value={formData.company}
                    onChange={handleChange}
                    error={!!errors.company}
                  />
                  {errors.company && (
                    <SoftTypography variant="caption" color="error">
                      {errors.company}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="email"
                    placeholder="E-Mail"
                    value={formData.email}
                    onChange={handleChange}
                    error={!!errors.email}
                  />
                  {errors.email && (
                    <SoftTypography variant="caption" color="error">
                      {errors.email}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="phone"
                    placeholder="Telefon"
                    value={formData.phone}
                    onChange={handleChange}
                    error={!!errors.phone}
                  />
                  {errors.phone && (
                    <SoftTypography variant="caption" color="error">
                      {errors.phone}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12}>
                <SoftTypography variant="h6" fontWeight="medium" mb={2}>
                  Rechnungsangaben
                </SoftTypography>
              </Grid>
              
              <Grid item xs={12}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="billingemail"
                    placeholder="Rechnungs-E-Mail"
                    value={formData.billingemail}
                    onChange={handleChange}
                    error={!!errors.billingemail}
                  />
                  {errors.billingemail && (
                    <SoftTypography variant="caption" color="error">
                      {errors.billingemail}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="billingaddress"
                    placeholder="Straße, Hausnummer"
                    value={formData.billingaddress}
                    onChange={handleChange}
                    error={!!errors.billingaddress}
                  />
                  {errors.billingaddress && (
                    <SoftTypography variant="caption" color="error">
                      {errors.billingaddress}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="billingzip"
                    placeholder="PLZ"
                    value={formData.billingzip}
                    onChange={handleChange}
                    error={!!errors.billingzip}
                  />
                  {errors.billingzip && (
                    <SoftTypography variant="caption" color="error">
                      {errors.billingzip}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="billingcity"
                    placeholder="Ort"
                    value={formData.billingcity}
                    onChange={handleChange}
                    error={!!errors.billingcity}
                  />
                  {errors.billingcity && (
                    <SoftTypography variant="caption" color="error">
                      {errors.billingcity}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <SoftBox mb={2}>
                  <SoftInput
                    name="billingcountry"
                    placeholder="Land"
                    value={formData.billingcountry}
                    onChange={handleChange}
                    error={!!errors.billingcountry}
                  />
                  {errors.billingcountry && (
                    <SoftTypography variant="caption" color="error">
                      {errors.billingcountry}
                    </SoftTypography>
                  )}
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
        </form>
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <SoftButton 
          onClick={onCancel} 
          variant="outlined" 
          color="secondary"
        >
          Abbrechen
        </SoftButton>
        <SoftButton 
          onClick={handleSubmit} 
          variant="gradient" 
          color="primary"
        >
          Kunden anlegen
        </SoftButton>
      </DialogActions>
    </>
  );
};

CustomerAddForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CustomerAddForm;